import apiCall from "./apiCall";

export default async function RestPasswordAPI(email, token, password, password_confirmation) {
    const URL = process.env.REACT_APP_API_URL+'/api/passwordreset';
    const BODY = {email: email, token: token, password: password, password_confirmation: password_confirmation}
    const data = await apiCall('POST', URL, BODY);
    return data;
};